import { render, staticRenderFns } from "./VerificationDocuments.vue?vue&type=template&id=7f262316&"
import script from "./VerificationDocuments.vue?vue&type=script&lang=js&"
export * from "./VerificationDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports